import { createFileRoute, redirect } from "@tanstack/react-router";

export const Route = createFileRoute("/_protected/superuser/")({
  beforeLoad: () => {
    throw redirect({ to: "/superuser/usage" });
  },
});
